import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DebugPage } from './debug';
import { SharedModule } from '../../../shared';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    DebugPage
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([{ path: '', component: DebugPage }]),
    IonicModule,
    SharedModule
  ]
})
export class DebugPageModule {}
